import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ConsultationWhatToExpectLanding = () => {
  const [searchParams] = useSearchParams();
  const selectedType = searchParams.get('consultation_type');
  const expertLabel = selectedType ? `${selectedType} expert` : 'expert';

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Helmet>
        <title>What To Expect | HireX8 Consultation</title>
        <meta
          name="description"
          content="Your consultation request has been received. Here is what to expect next from HireX8."
        />
      </Helmet>

      <section className="py-16 sm:py-24 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center text-sm font-semibold text-orange-600 hover:opacity-80 mb-6">
            ← Back to HireX8
          </Link>

          <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 text-sm font-medium uppercase tracking-wider text-orange-600 mb-4">
              <span className="w-2 h-2 rounded-full bg-orange-500" />
              Consultation Request Received
            </div>

            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900 mb-8">
              What To Expect
            </h1>

            <ol className="space-y-5 text-lg text-gray-700 leading-relaxed list-decimal pl-6">
              <li>Our team will be in contact to schedule your consultation session.</li>
              <li>Correspondence will be via email, so please check your spam folder if you do not receive a follow-up within 30 minutes.</li>
              <li>Once a time is booked, you will receive a payment link to pay for your session.</li>
              <li>Payment is required prior to meeting with your {expertLabel}.</li>
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConsultationWhatToExpectLanding;
